import styled from '@emotion/styled';
import { Stack, Typography } from '@mui/material';
import { theme } from 'theme';

export const FormContainer = styled('form')`
  width: 600px;
  margin: auto;
  margin-top: 60px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  @media (max-width: 768px) {
    width: 90%;
  }
`;

export const LabelCheckbox = styled(Typography)`
  padding-top: 16px;
  font-size: 14px;
  font-weight: 400;
  line-height: 17.5px;
  & > span {
    color: ${theme.palette.primary.main};
  }
`;

export const LabelWrap = styled(Stack)`
  flex-direction: row;
  padding-left: 34px;
`;

export const MoreActions = styled(Stack)`
  margin: auto;
`;

export const AnChildItem = styled(Stack)`
  flex-direction: row;
  align-items: center;
  gap: 16px;
  margin-bottom: 16px;
`;

export const AddressAction = styled(Stack)`
  font-size: 13px;
  font-weight: 400;
  line-height: 13px;
  color: ${theme.palette.secondary.main};
  cursor: pointer;
`;

export const Actions = styled(Stack)`
  margin: auto;
  margin-top: 30px;
  width: 100%;
`;
